import { LIST, VIEW, ADD, EDIT, DELETE } from "const"
import { LangType } from "client/store"
import Lang from "client/store/lang"

import * as Const from "./const"
import {
    PermissionStructure,
    AccountPermissions,
    AccountPermissionsSectioned,
} from "./types"
import {
    copyPermissionRow,
    accountPermissionRow,
} from "./functions"

// eslint-disable-next-line import/prefer-default-export
export const createAccountPermissions = (targetLang?: LangType) => {
    const lang = targetLang || Lang
    const structure: PermissionStructure = {
        account: [
            {
                permissionId: Const.PRM_HELP,
                title: lang.help,
                unused: [LIST, VIEW, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_ACCOUNT,
                title: lang.account,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_BILLING,
                title: lang.billing,
                unused: [VIEW, EDIT],
            },
            {
                permissionId: Const.PRM_GROUP,
                title: lang.group,
            },
            {
                permissionId: Const.PRM_PERMISSIONS,
                title: lang.permissions,
                unused: [VIEW, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_ACCOUNT_SETTINGS,
                title: lang.accountSettings,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_PROJECT,
                title: lang.project,
            },
            {
                permissionId: Const.PRM_TASK,
                title: lang.task,
            },
            {
                permissionId: Const.PRM_DRIVE,
                title: lang.drive,
            },
            {
                permissionId: Const.PRM_COMMENTS,
                title: lang.comments,
                unused: [LIST, VIEW, ADD],
            },
        ],
        complianceCase: [
            {
                permissionId: Const.PRM_CC_LIBRARY,
                title: lang.library,
            },
        ],
        lifecycle: [
            {
                permissionId: Const.PRM_LIFECYCLE,
                title: lang.lifecycle,
            },
        ],
        qid: [
            {
                permissionId: Const.PRM_QID_COMPANY,
                title: lang.company,
            },
            {
                permissionId: Const.PRM_QID_PRODUCT,
                title: lang.product,
            },
        ],
        sil: [
            {
                permissionId: Const.PRM_SIL_DEVICE,
                title: lang.device,
            },
            {
                permissionId: Const.PRM_SIL_SUBSYSTEM,
                title: lang.subsystem,
            },
        ],
        okr: [
            {
                permissionId: Const.PRM_OKR_SESSION,
                title: lang.session,
            },
            {
                permissionId: Const.PRM_OKR_OBJECTIVE_KEY_RESULT,
                title: lang.objectivesKeyResults,
            },
        ],
        rrs: [
            /* { TODO: temporarily disabled
                permissionId: Const.PRM_RRS_CATEGORY,
                title: lang.lexicon,
                unused: [VIEW],
            }, */
            {
                permissionId: Const.PRM_RRS_TEMPLATE,
                title: lang.riskSpaceTemplates,
            },
        ],
        markov: [
            {
                permissionId: Const.PRM_MARKOV_MODEL,
                title: lang.model,
            },
        ],
    }

    const { permissions, permissionsSectioned } = copyPermissionRow(structure, accountPermissionRow)
    return {
        permissions: <AccountPermissions>permissions,
        permissionsSectioned: <AccountPermissionsSectioned>permissionsSectioned,
    }
}
